/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  ConfirmTransaction: (params: vp.ConfirmTransactionRequest) => void,
  reset: () => void,
  ConfirmTransactionAsync: (params: vp.ConfirmTransactionRequest) => Promise<vp.ApiResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostConfirmTransaction: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldConfirmTransaction, setShouldConfirmTransaction] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.ConfirmTransactionRequest>({
    TransactionID: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldConfirmTransaction) return () => {};

    const PostConfirmTransaction = async () => {
      setDataFetchingInfo(true, 'Loading', 'fullScreen');
      const res = await api.postConfirmTransaction(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldConfirmTransaction) void PostConfirmTransaction();
    setShouldConfirmTransaction(false);
    return () => {
      source.cancel();
    };
  }, [shouldConfirmTransaction]);

  return [
    response,
    (_params: vp.ConfirmTransactionRequest) => {
      setParams(_params);
      setShouldConfirmTransaction(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldConfirmTransaction(false);
    },
    (_params: vp.ConfirmTransactionRequest) => api.postConfirmTransaction(_params, source),
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostConfirmTransaction);
